import { buildPermissionMap } from './permissionMap';

const LEARNING_PERMISSIONS = new Set([
  'dashboard_management_view', 'profile_management_view', 'profile_management_edit',
  'course_management_view', 'course_module_management_view', 'course_module_content_management_view',
  'classroom_management_view', 'classroom_assignment_view', 'classroom_assessment_view',
  'classroom_resources_view', 'classroom_liveclasses_view', 'classroom_live_classes_view',
  'classroom_courses_view', 'classroom_community_view', 'classroom_assignment_resource_view',
  'classroom_assessment_question_view', 'notification_management_view', 'certificate_management_view',
]);

export function usesLearnerWorkspace(role, permissions = {}) {
  const name = String(role || '').trim().toLowerCase();
  if (name === 'trainee') return true;
  if (['admin', 'trainer'].includes(name)) return false;
  const granted = [...new Set(Object.entries(permissions)
    .filter(([, value]) => value === true || Number(value) === 1)
    .map(([slug]) => slug.replace(/-/g, '_')))];
  return granted.length > 0 && granted.every((slug) => LEARNING_PERMISSIONS.has(slug));
}

export function postLoginDashboard(role, permissions) {
  const map = Array.isArray(permissions) ? buildPermissionMap(permissions) : permissions;
  return usesLearnerWorkspace(role, map) ? '/user/dashboard' : '/admin/dashboard';
}

// Notification deep links are the only supported return target today. Ignore
// stale or malformed session values (for example "/") so login always lands
// on a route that exists for the authenticated workspace.
export function resolvePostLoginTarget(role, permissions, pendingRedirect) {
  if (typeof pendingRedirect === 'string' && /^\/n\/go(?:\?.*)?$/.test(pendingRedirect)) {
    return pendingRedirect;
  }
  return postLoginDashboard(role, permissions);
}

export function currentDashboard() {
  try { return postLoginDashboard(localStorage.getItem('role'), JSON.parse(localStorage.getItem('permissions') || '{}')); }
  catch { return '/user/dashboard'; }
}
